import React from "react";

class Sidebar extends React.Component {
  render() {
    return (
      <div className="col-lg-3 sidebar_col">
        <div className="sidebar">
          <br></br>
          <p>
            {" "}
            <img
              src={require("../assets/springerlink.jpg")}
              width="230"
              height="auto"
            />{" "}
          </p>
          <div className="categories sidebar_list">
            <div className="sidebar_title">Proceedings</div>
            <ul>
              <li>
                <a href="https://link.springer.com/series/17396" target="_blank">
                  Springer Book
                </a>
                <a href="https://link.springer.com/series/17396" target="_blank">
                  <img src={require("../assets/isem.png")} width="230" height="340" />
                </a>
              </li>
            </ul>
          </div>
          <div className="categories sidebar_list">
            <img src={require("../assets/scholar.png")} width="230" height="auto" />
          </div>
          <br></br>
          <div className="categories sidebar_list">
            <img src={require("../assets/web.png")} width="230" height="auto" />
          </div>

          {/* Featured Event Advertisement */}
          <br></br>
          <div className="categories sidebar_list">
            <div className="sidebar_title">Featured Event</div>
            <div className="card border-0 shadow-sm rounded-3 overflow-hidden">
              <div
                className="card-header text-white text-center py-3"
                style={{ backgroundColor: "#1a73e8" }}
              >
                <small className="text-uppercase fw-bold">Workshop</small>
              </div>

              <div className="card-body text-center px-3 py-4">
                <h5 className="fw-bold mb-2" style={{ color: "#1a1a2e" }}>
                  Applied Machine Learning in Health
                </h5>

                <p className="text-muted small mb-4">
                  A workshop co-located with CAAIE 2026, Cardiff, UK &mdash; 6
                  August 2026.
                </p>

                
                 <a href="https://workshop.icita.world/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-sm w-100 text-white fw-semibold"
                  style={{ backgroundColor: "#1a73e8" }}
                >
                  Learn More &rarr;
                </a>
              </div>

              <div
                className="card-footer text-center py-2"
                style={{ backgroundColor: "#f8f9ff" }}
              >
                <small className="text-muted">
                  <i className="bi bi-geo-alt me-1"></i>
                  Co-located with CAAIE 2026
                </small>
              </div>
            </div>
          </div>

        </div>
      </div>
    );
  }
}

export default Sidebar;